module.exports = __webpack_public_path__ + "static/img/icon-clearbit.d5110ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-clearbit.svg
// module id = 446
// module chunks = 0